<template>
  <div class="icon" :class="{[type]: true}"></div>
</template>

<script>
const iconType = [
  'refresh',
  'error',
  'email',
  'group',
  'qq',
  'wechat',
  'telephone',
  'er-code',
  // dark
  'dark-edit',
  'dark-tip',
  'dark-rubbish',
  'dark-rubbishSel',
  'dark-download',
  'dark-downloadSel',
  'dark-offline',
  // default
  'default-edit',
  'default-tip',
  'default-rubbish',
  'default-rubbishSel',
  'default-download',
  'default-downloadSel',
  'default-offline'
]
export default {
  name: 'Icon',
  props: {
    type: {
      type: String,
      required: true,
      validator: (value) => new RegExp(iconType.map(item => `(${item})`).join('|')).test(value)
    }
  }
}
</script>

<style scoped="scoped">
.icon {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
}
.refresh {
  background: url('../assets/refresh.png') center center / 70% 70% no-repeat;
}
.error {
  background: url('../assets/error.png') center center / 80% 80% no-repeat;
}
.email {
  background: url('../assets/email.png') center center / 70% 53% no-repeat;
}
.group {
  background: url('../assets/group.png') center center / 70% 70% no-repeat;
}
.qq {
  background: url('../assets/qq.png') center center / 65% 70% no-repeat;
}
.wechat {
  background: url('../assets/wechat.png') center center / 70% 58% no-repeat;
}
.telephone {
  background: url('../assets/telephone.png') center center / 70% 70% no-repeat;
}
.er-code {
  background: url('../assets/er-code.jpeg') center center / 70% 70% no-repeat;
}
.dark-edit {
  background: url('../assets/default-edit.png') center center / 90% 90% no-repeat;
}
.dark-tip {
  background: url('../assets/default-tip.png') center center / 100% 100% no-repeat;
}
.dark-rubbish {
  background: url('../assets/default-rubbish.png') center center / 100% 100% no-repeat;
}
.dark-rubbishSel {
  background: url('../assets/default-rubbishSel.png') center center / 100% 100% no-repeat;
}
.dark-download {
  background: url('../assets/default-download.png') center center / 100% 100% no-repeat;
}
.dark-downloadSel {
  background: url('../assets/default-downloadSel.png') center center / 100% 100% no-repeat;
}
.dark-offline {
  background: url('../assets/default-offline.png') center center / 100% 100% no-repeat;
}

.default-edit {
  background: url('../assets/default-edit.png') center center / 90% 90% no-repeat;
}
.default-tip {
  background: url('../assets/default-tip.png') center center / 100% 100% no-repeat;
}
.default-rubbish {
  background: url('../assets/default-rubbish.png') center center / 100% 100% no-repeat;
}
.default-rubbishSel {
  background: url('../assets/default-rubbishSel.png') center center / 100% 100% no-repeat;
}
.default-download {
  background: url('../assets/default-download.png') center center / 100% 100% no-repeat;
}
.default-downloadSel {
  background: url('../assets/default-downloadSel.png') center center / 100% 100% no-repeat;
}
.default-offline {
  background: url('../assets/default-offline.png') center center / 100% 100% no-repeat;
}
</style>



// WEBPACK FOOTER //
// src/components/Icon.vue